<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch("utils/setSectionName", "Impostazioni");
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/settings/profile/ProfilePage.vue